import AgentFormsRouteConstants, {ROOT_URI} from 'Agent/AgentForms/AgentFormsRouteConstants';
import Bulletins from 'Agent/AgentForms/Bulletins/components/Bulletins';
import InteractiveForm from 'Agent/AgentForms/Interactive/components/InteractiveForm';
import Marketing from 'Agent/AgentForms/Marketing/components/Marketing';
import PreviousOrders from 'Agent/AgentForms/PreviousOrders/components/PreviousOrders';
import React from 'react';
import {Route, RouteComponentProps, Switch} from 'react-router';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {UserClaims} from 'Users/models/Claims';

type AgentFormsProps = {
    selectedAgency: AgencyFilters;
    claims: UserClaims;
} & RouteComponentProps;

export default ({selectedAgency, claims}: AgentFormsProps) => {
    return (
        <Route
            path={ROOT_URI}
            render={() => (
                <Switch>
                    <Route
                        path={AgentFormsRouteConstants.AGENCY_BULLETIN}
                        render={routeProps => <Bulletins {...routeProps} selectedAgency={selectedAgency}/>}
                        exact
                    />
                    <Route
                        exact
                        path={AgentFormsRouteConstants.INTERACTIVE_FORMS}
                        render={routeProps => <InteractiveForm {...routeProps} selectedAgency={selectedAgency}
                                                               claims={claims}/>}
                    />
                    <Route
                        exact
                        path={AgentFormsRouteConstants.MARKETING_FORMS}
                        render={routeProps => <Marketing {...routeProps} selectedAgency={selectedAgency}/>}
                    />
                    <Route
                        exact
                        path={AgentFormsRouteConstants.PREVIOUS_ORDERS}
                        render={routeProps => <PreviousOrders {...routeProps} selectedAgency={selectedAgency}/>}
                    />
                </Switch>
            )}
        />
    )
};
